/**
 * Page metadata from src/content/help/seo.js: the same tags the pre-renderer
 * writes into the static HTML (headTags), so both always agree.
 */
import PropTypes from 'prop-types';
import PageSeo from '@/components/PageSeo';

export default function HelpSeo({ meta }) {
  if (!meta) return null;
  return <PageSeo meta={meta} />;
}
HelpSeo.propTypes = { meta: PropTypes.object };
